module.exports = __webpack_public_path__ + "img/altlift.5d3a1d4c.png";